import React from "react";
import { useStateMachine } from "little-state-machine";
import "./App.css";
import Header from "../assets/images/Header.png";
import Step3 from "../assets/images/stepbar_3.png";
import Icon from "../assets/images/thanks.png";

export default function FormComplete() {
  const { state } = useStateMachine();

  return (
    <>
      <div className="layout">
        <div className="layout__content">
          <img src={Header} alt="" />
          <div className="container">
            <div className="row" style={{ alignItems: "flex-start" }}>
              <img src={Step3} alt="" className="stepbar" />
              <div
                className="box__text_thanks"
                style={{ alignItems: "flex-start" }}
              >
                <img src={Icon} alt="" className="icon_thanks" />
                <div className="text_thanks">
                  <span>{state.personalName}　様</span>
                  <br />
                  <span style={{ fontWeight: "bold" }}>
                    ご注文ありがとうございます。
                  </span>
                  <br />
                  <span>
                    ご注文内容は、配信された【注文確認メール】よりご確認下さい。
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
